"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_SSO_PROVIDERS = exports.errorCodes = exports.SERVICE_NAME = void 0;
// Used by other services to reference this one in the dependency map
exports.SERVICE_NAME = 'schools-service';
exports.errorCodes = Object.freeze({
    NO_ACCESS_TO_SCHOOL: 'NO_ACCESS_TO_SCHOOL',
    SCHOOL_SYNC_EXPIRED: 'SCHOOL_SYNC_EXPIRED'
});
exports.SUPPORTED_SSO_PROVIDERS = ['google', 'microsoft'];
//# sourceMappingURL=index.js.map